export default "__VITE_ASSET__BpaqKsUK__"